import { schema } from 'normalizr';

const transactionGOSSchema = new schema.Entity('transactionGOS');

export default transactionGOSSchema;
